// This class should be used on scenarios where VC can not be calculate
// such as: SSR environment and legacy browsers
export class VCObserverNOOP {
  start(_) {}
  stop() {}
  getVCRawData() {
    return null;
  }
  getVCResult(_) {
    return Promise.resolve({
      'ufo:vc:noop': true
    });
  }
  setSSRElement(_) {}
  setReactRootRenderStart(_) {}
  setReactRootRenderStop(_) {}
}